<template>
  <p class="date">
      {{releaseDate}}
  </p>
</template>

<script>
import { mapState } from "vuex";
import { localeDateString } from "@/common/localedate";

export default {
  name: "ReleaseDateForArticle",
  props: {
    fcontId: String
  },
  components: {
  },
  computed: {
    ...mapState('articles', ['articles', 'articlesStatus']),
    releaseDate: function() {
      if(this.articlesStatus == false || this.articles.length == 0) {
        return " "
      }else {
        const item = this.articles.find(
          article => String(article.id) == this.fcontId
        )
        if(item == undefined) {
          // 海外からJP限定公開記事を見たときにこのケースに陥る
          return " "
        }else {
          return localeDateString(item.releaseDate, this.$store.state.lg2)
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date {
  font-size: 12px;
  color: #8d8d8d; 
  text-align: right; 
  width: 100%; 
  max-width: 720px; 
  margin-left: auto; 
  margin-right: auto;
}
</style>